// PC图片库接口
import request from '@/utils/request'
// 显示文件目录
export function libray_show_folder(data) {
    return request({
        url: '/libray/show_folder',
        method: 'get',
        params: data
    })
}
// 获取图片库空间
export function libray_img_info(data) {
    return request({
        url: '/libray/img_info',
        method: 'get',
        params: data
    })
}
// 获取所有图片
export function libray_show_img_list(data) {
    return request({
        url: '/libray/show_img_list',
        method: 'get',
        params: data
    })
}
// 创建或修改目录
export function libray_create_folder(data) {
    return request({
        url: '/libray/create_folder',
        method: 'post',
        data
    })
}
// 删除文件目录
export function libray_del_folder(data) {
    return request({
        url: '/libray/del_folder',
        method: 'post',
        data
    })
}
// 删除图片
export function libray_delete_img(data) {
    return request({
        url: '/libray/delete_img',
        method: 'post',
        data
    })
}